"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

exports.default = game;

var _deepmerge = require("deepmerge");

var _deepmerge2 = _interopRequireDefault(_deepmerge);

var _redux = require("../libs/utils/redux");

var _GameActionTypes = require("../constants/action-types/GameActionTypes");

var types = _interopRequireWildcard(_GameActionTypes);

var _Misc = require("../constants/Misc");

var _PlayerStatuses = require("../constants/PlayerStatuses");

var playerStatuses = _interopRequireWildcard(_PlayerStatuses);

var _game = require("../selectors/game");

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var initialState = {
  isCounting: false,
  elapsed: 0,
  roomName: "school-of-code",
  roomId: undefined,
  currentTaskNumber: 0,
  playerNames: [],
  invites: [],
  roomSize: 2,
  entities: {
    playerStatesById: {},
    // TODO: should be an array
    tasks: {},
    playerInfoById: {},
    eventsMap: {}
  }
};
var initialPlayerState = {
  code: [],
  currentEditorIndex: 0,
  status: playerStatuses.DEFAULT,
  isConnected: false,
  codeResult: {
    err: "",
    out: ""
  },
  characterName: undefined
};

function game() {
  var game = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case types.SET_ROOM_ID:
      return setRoomId(game, payload);

    case types.SET_GAME_STATE:
      return setState(game, payload);

    case types.SETUP_CHALLENGE:
      return setupChallenge(game, payload);
    //user functions

    case types.CODE_CHANGED:
      return codeChanged(game, payload);
    //+Server Async Actions+
    //Running code

    case types.RUN_CODE_REQUEST:
      return runCodeRequest(game, payload);

    case types.RECEIVE_RUN_CODE_RESULT:
      return receiveRunCodeResult(game, payload);
    //Submitting code

    case types.RECEIVE_SUBMIT_CODE_RESULT:
      return receiveSubmitCodeResult(game, payload);

    case types.DO_SKIP_TASK:
      return doSkipTask(game);

    case types.SET_SKELETON_CODE:
      return setSkeletonCode(game, payload);

    case types.SET_ALL_SKELETON_CODE:
      return setAllSkeletonCode(game);

    case types.RESET_STATUSES_TO_DEFAULT:
      return resetToDefaultState(game);
    // case types.RECEIVE_SKIP_TASK_RESULT:
    //   return receiveSkipTaskResult(state, action.payload);

    case types.SET_PLAYER_STATE:
      return setPlayerState(game, payload);

    case types.SET_PLAYER_EDITOR_INDEX:
      return setPlayerEditorIndex(game, payload);
    //Adding a player

    case types.ADD_PLAYER:
      return doAddPlayer(game, payload);
    //Inviting player

    case types.INVITE_PLAYER:
      return doInvitePlayer(game, payload);
    //Removing a player

    case types.REMOVE_PLAYER:
      return doRemovePlayer(game, payload);
    //player connect/disconnect

    case types.CONNECT_PLAYER:
      return doConnectPlayer(game, payload);

    case types.DISCONNECT_PLAYER:
      return doDisconnectPlayer(game, payload);

    case types.START_COUNTING:
      return startCounting(game);

    case types.STOP_COUNTING:
      return stopCounting(game);
    //button click

    case types.BUTTON_TYPE_CLICKED:
      return setButtonTypeClicked(game, payload);
    //server functions

    case types.SET_ELAPSED:
      return setElapsed(game, payload);

    case types.SET_CODE:
      return setCode(game, payload);

    default:
      return game;
  }
}

var setRoomId = function setRoomId(game, _ref2) {
  var roomId = _ref2.id;
  return _extends({}, game, {
    roomId: roomId
  });
}; // TODO: Originally this was a deepMerge of chat and payload state, does this new func still work?


var setState = function setState(game, _ref3) {
  var state = _ref3.state;
  return state;
};

var setupChallenge = function setupChallenge(game, _ref4) {
  var roomId = _ref4.roomId,
      entities = _ref4.entities;
  return _extends({}, game, {
    roomId: roomId,
    entities: _extends({}, game.entities, entities, {
      playerStatesById: _extends({}, game.entities.playerStatesById, entities.playerStatesById)
    })
  });
}; //User Functions


var codeChanged = function codeChanged(game, _ref5) {
  var playerId = _ref5.playerId,
      code = _ref5.code,
      codeIndex = _ref5.codeIndex;
  var playerState = game.entities.playerStatesById[playerId];
  var oldCode = playerState.code,
      status = playerState.status; // Deep, nested object :-\ Should try and flatten this..
  // see https://redux.js.org/recipes/structuringreducers/immutableupdatepatterns#correct-approach-copying-all-levels-of-nested-data

  return (0, _deepmerge2.default)(game, {
    entities: {
      playerStatesById: _defineProperty({}, playerId, {
        code: (0, _redux.setItem)(oldCode, codeIndex, code),
        status: status === playerStatuses.DONE ? playerStatuses.DEFAULT : status
      })
    }
  }, // little bit of a hack to stop the code arrays from merging. Might result in incorrect behaviour for other arrays in the tree
  // best to just flatten this part of the tree!
  {
    arrayMerge: function arrayMerge(destinationArray, sourceArray) {
      return sourceArray;
    }
  });
}; //Server Functions


var setElapsed = function setElapsed(game, _ref6) {
  var elapsed = _ref6.elapsed;
  return _extends({}, game, {
    elapsed: elapsed
  });
};

var setPlayerState = function setPlayerState(game, _ref7) {
  var playerId = _ref7.playerId,
      playerState = _ref7.playerState;
  return (0, _deepmerge2.default)(game, {
    entities: {
      playerStatesById: _defineProperty({}, playerId, {
        status: playerState
      })
    }
  });
};

var setPlayerEditorIndex = function setPlayerEditorIndex(game, _ref8) {
  var playerId = _ref8.playerId,
      editorIndex = _ref8.editorIndex;
  return (0, _deepmerge2.default)(game, {
    entities: {
      playerStatesById: _defineProperty({}, playerId, {
        currentEditorIndex: editorIndex
      })
    }
  });
}; //+Server Async Actions+


var runCodeRequest = function runCodeRequest(game, _ref9) {
  var playerId = _ref9.playerId;
  return (0, _deepmerge2.default)(game, {
    entities: {
      playerStatesById: _defineProperty({}, playerId, {
        status: playerStatuses.RUNNING
      })
    }
  });
};

var receiveRunCodeResult = function receiveRunCodeResult(game, _ref10) {
  var valid = _ref10.valid,
      playerId = _ref10.playerId,
      codeResult = _ref10.codeResult;
  return _extends({}, game, {
    entities: _extends({}, game.entities, {
      playerStatesById: _extends({}, game.entities.playerStatesById, _defineProperty({}, playerId, _extends({}, game.entities.playerStatesById[playerId], {
        status: valid ? playerStatuses.PASSED : playerStatuses.FAILED,
        codeResult: codeResult
      })))
    })
  }); // merge(game, {
  //   entities: {
  //     playerStatesById: {
  //       [playerId]: {
  //         status: valid ? playerStatuses.PASSED : playerStatuses.FAILED,
  //         codeResult
  //       }
  //     }
  //   }
  // });
};

var receiveSubmitCodeResult = function receiveSubmitCodeResult(game, _ref11) {
  var valid = _ref11.valid,
      playerId = _ref11.playerId,
      codeResult = _ref11.codeResult;
  return (0, _deepmerge2.default)(game, {
    entities: {
      playerStatesById: _defineProperty({}, playerId, {
        status: valid ? playerStatuses.DONE : playerStatuses.FAILED,
        codeResult: codeResult
      })
    }
  });
}; //Skipping a task


var doSkipTask = function doSkipTask(game) {
  var max = (0, _game.selectNumberOfTasks)({
    game: game
  }) - 1;
  var next = (0, _game.selectCurrentTaskNumber)({
    game: game
  }) + 1;
  return _extends({}, game, {
    currentTaskNumber: Math.min(max, next)
  });
};
/**
 * Get's skeleton code from the currentPlayerInfos and sets them
 * in the playerState.code for each player
 */


var setSkeletonCode = function setSkeletonCode(game, _ref12) {
  var playerId = _ref12.playerId; // TODO: Not sure { game } in selector is a good pattern. Especially when we get sub-reducers that are combined

  var playerInfo = (0, _game.selectPlayerInfoFromPlayerId)({
    game: game
  }, playerId);
  var languages = playerInfo.languages,
      skeleton = playerInfo.skeleton;
  return _extends({}, game, {
    entities: _extends({}, game.entities, {
      playerStatesById: _extends({}, game.entities.playerStatesById, _defineProperty({}, playerId, {
        code: skeleton && skeleton.length ? skeleton : languages.map(function () {
          return "";
        })
      }))
    })
  });
};
/**
 * Get's all skeleton code from the currentPlayerInfos and sets them
 * in the playerState.code for each player
 */


var setAllSkeletonCode = function setAllSkeletonCode(game) {
  var playerStatesById = Object.entries(game.entities.playerStatesById).reduce(function (acc, cur) {
    var _cur = _slicedToArray(cur, 2),
        key = _cur[0],
        value = _cur[1];

    var _selectPlayerInfoFrom = (0, _game.selectPlayerInfoFromPlayerId)({
      game: game
    }, key),
        languages = _selectPlayerInfoFrom.languages,
        skeleton = _selectPlayerInfoFrom.skeleton;

    return _extends({}, acc, _defineProperty({}, key, _extends({}, value, {
      code: skeleton && skeleton.length ? skeleton : languages.map(function () {
        return "";
      })
    })));
  }, {});
  return _extends({}, game, {
    entities: _extends({}, game.entities, {
      playerStatesById: playerStatesById
    })
  }); // merge(game, {
  //   entities: {
  //     playerStatesById
  //   }
  // });
};

var setCode = function setCode(game, _ref13) {
  var playerId = _ref13.playerId,
      code = _ref13.code;

  if (!code || !code.length) {
    return game;
  }

  var playerInfo = (0, _game.selectPlayerInfoFromPlayerId)({
    game: game
  }, playerId);
  var languages = playerInfo && playerInfo.languages || [];
  var newCode = languages.map(function (lng) {
    return code.find(function (_ref14) {
      var type = _ref14.type;
      return type === lng;
    });
  }).map(function (_ref15) {
    var content = _ref15.content;
    return content;
  });
  return (0, _deepmerge2.default)(game, {
    entities: {
      playerStatesById: _defineProperty({}, playerId, {
        code: newCode
      })
    }
  }, // little bit of a hack to stop the code arrays from merging. Might result in incorrect behaviour for other arrays in the tree
  // best to just flatten this part of the tree!
  {
    arrayMerge: function arrayMerge(destinationArray, sourceArray) {
      return sourceArray;
    }
  });
};

var resetToDefaultState = function resetToDefaultState(game) {
  return (0, _deepmerge2.default)(game, {
    entities: {
      playerStatesById: Object.keys(game.entities.playerStatesById).reduce(function (acc, cur) {
        return _defineProperty({}, cur, {
          status: playerStatuses.DEFAULT
        });
      }, {})
    }
  });
};

var doInvitePlayer = function doInvitePlayer(game, _ref17) {
  var playerName = _ref17.playerName;
  return _extends({}, game, {
    invites: [].concat(_toConsumableArray(game.invites), [playerName])
  });
};

var doAddPlayer = function doAddPlayer(game, _ref18) {
  var playerName = _ref18.playerName,
      index = _ref18.index;
  return _extends({}, game, {
    playerNames: (0, _redux.setItem)(game.playerNames, index, playerName),
    entities: _extends({}, game.entities, {
      playerStatesById: _extends({}, game.entities.playerStatesById, _defineProperty({}, index, initialPlayerState))
    })
  }); // merge(
  //   game,
  //   {
  //     playerNames: setItem(game.playerNames, index, playerName),
  //     entities: {
  //       playerStatesById: {
  //         [index]: initialPlayerState
  //       }
  //     }
  //   },
  //   // little bit of a hack to stop the code arrays from merging. Might result in incorrect behaviour for other arrays in the tree
  //   // best to just flatten this part of the tree!
  //   { arrayMerge: (destinationArray, sourceArray) => sourceArray }
  // );
};

var doRemovePlayer = function doRemovePlayer(game, _ref19) {
  var playerId = _ref19.playerId;
  return (0, _deepmerge2.default)(game, {
    playerNames: (0, _redux.setItem)(game.playerNames, playerId, _Misc.EMPTY_PLAYER_SLOT),
    entities: {
      playerStatesById: _defineProperty({}, playerId, undefined)
    }
  });
}; //player connect/disconnect


var doConnectPlayer = function doConnectPlayer(game, _ref20) {
  var playerId = _ref20.playerId;
  return (0, _deepmerge2.default)(game, {
    entities: {
      playerStatesById: _defineProperty({}, playerId, {
        isConnected: true
      })
    }
  });
};

var doDisconnectPlayer = function doDisconnectPlayer(game, _ref21) {
  var playerId = _ref21.playerId;
  return (0, _deepmerge2.default)(game, {
    entities: {
      playerStatesById: _defineProperty({}, playerId, {
        isConnected: false
      })
    }
  });
};

var startCounting = function startCounting(game) {
  return _extends({}, game, {
    isCounting: true
  });
};

var stopCounting = function stopCounting(game) {
  return _extends({}, game, {
    isCounting: false
  });
};

var setButtonTypeClicked = function setButtonTypeClicked(game, _ref22) {
  var buttonType = _ref22.buttonType;
  return _extends({}, game, {
    buttonTypeClicked: buttonType
  });
};